import { observable, runInAction, toJS } from 'mobx';
import isObject from 'lodash/isObject';
import { RecordStatus } from '../data-set/enum';
import defaultFeedback from '../data-set/FeedBack';
import { defaultValidationMessageFormatter, defaultValidationMessageReportFormatter, } from '../validator/ValidationMessageReportFormatter';
const defaultLookupCache = { maxAge: 1000 * 60 * 10, max: 100 };
const defaultStatus = { [RecordStatus.add]: 'add', [RecordStatus.update]: 'update', [RecordStatus.delete]: 'delete' };
const defaultFormatter = {
    jsonDate: 'YYYY-MM-DD HH:mm:ss',
    date: 'YYYY-MM-DD',
    dateTime: 'YYYY-MM-DD HH:mm:ss',
    time: 'HH:mm:ss',
    year: 'YYYY',
    month: 'YYYY-MM',
    week: 'GGGG-Wo',
};
const defaultAttachment = {
    defaultFileKey: 'file',
    defaultFileSize: 0,
    getDownloadUrl({ attachment }) {
        return attachment.url;
    },
};
const defaultConfig = {
    lookupCache: defaultLookupCache,
    lookupUrl: code => `/common/code/${code}/`,
    lookupAxiosMethod: 'post',
    lovDefineUrl: code => `/sys/lov/lov_define?code=${code}`,
    lovQueryUrl: code => `/common/lov/dataset/${code}`,
    dataKey: 'rows',
    totalKey: 'total',
    statusKey: '__status',
    tlsKey: '__tls',
    status: defaultStatus,
    feedback: defaultFeedback,
    formatter: defaultFormatter,
    attachment: defaultAttachment,
    confirm: (_) => Promise.resolve(true),
    validationMessageFormatter: defaultValidationMessageFormatter,
    validationMessageReportFormatter: defaultValidationMessageReportFormatter,
};
const defaultGlobalConfig = observable.map(defaultConfig);
const globalConfig = observable.map();
const baseMergeProps = ['transport', 'feedback', 'formatter', 'attachment'];
export function getConfig(key) {
    const custom = globalConfig.get(key);
    const hasCustom = globalConfig.has(key);
    if (!hasCustom) {
        return defaultGlobalConfig.get(key);
    }
    if (baseMergeProps.includes(key)) {
        return {
            ...defaultGlobalConfig.get(key),
            ...custom,
        };
    }
    return custom;
}
export function overwriteDefaultConfig(config, mergeProps = baseMergeProps) {
    runInAction(() => {
        Object.keys(config).forEach((key) => {
            const configKey = key;
            const value = config[configKey];
            if (mergeProps && mergeProps.includes(configKey) && isObject(value)) {
                defaultGlobalConfig.set(configKey, {
                    ...toJS(defaultGlobalConfig.get(configKey)),
                    ...value,
                });
            }
            else {
                defaultGlobalConfig.set(configKey, config[configKey]);
            }
        });
    });
}
export function overwriteConfigMergeProps(customMergeProps) {
    baseMergeProps.push(...customMergeProps);
}
export default function configure(config, mergeProps = baseMergeProps) {
    runInAction(() => {
        Object.keys(config).forEach((key) => {
            const configKey = key;
            const value = config[configKey];
            if (mergeProps && mergeProps.includes(configKey) && isObject(value)) {
                globalConfig.set(configKey, {
                    ...toJS(globalConfig.get(configKey)),
                    ...value,
                });
            }
            else {
                globalConfig.set(configKey, config[configKey]);
            }
        });
    });
}
